// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_bb-0";
export var optionCard = "_bb-1";